import ApiService from "../utils/ApiService";

export class DisbursementService {
  #calculateFields = [
    "Net Total",
    "VAT",
    "SD",
    "Discount",
    "Gross Total",
    "Sold Price",
    "Amount",
  ];

  constructor() {}

  getCalculateField() {
    return this.#calculateFields;
  }

  static getCalculationFields() {
    const instance = new DisbursementService();
    return instance.getCalculateField();
  }

  static getTableColumns(data) {
    if (data.length < 1) {
      return;
    }

    let cols = Object.keys(data[0]);
    for (let i = 0; i < cols.length; i++) {
      let tempColName = cols[i].replace(/([A-Z])/g, " $1").trim();
      cols[i] = tempColName.charAt(0).toUpperCase() + tempColName.slice(1);
      if (cols[i].length <= 3) {
        cols[i] = cols[i].toUpperCase();
      }
    }
    cols = ["SN", ...cols];

    return cols;
  }

  static getHeaderTextColor(colName) {
    const colors = ["#000000", "#341557"];
    const blackText = ["VAT", "SD", "Discount", "Mobile", "Order Type"];
    return blackText.includes(colName)
      ? `text-[${colors[0]}]`
      : `text-[${colors[1]}]`;
  }

  static placeCurrencyText(val) {
    if (typeof val === "string" && !isNaN(val.trim())) {
      if (val.split(".").length > 1) {
        return true;
      }
    }
    return false;
  }

  static #getFieldFromCol(name) {
    if (name.length <= 3) {
      return name.toLowerCase();
    } else {
      name = name.split(" ").join("");
      return name.charAt(0).toLowerCase() + name.slice(1);
    }
  }

  static getColumnTotal(reports, col) {
    let total = 0;
    const fieldName = this.#getFieldFromCol(col);

    reports.map((report) => {
      total += Number(report[fieldName]);
    });
    return total.toLocaleString("en", { minimumFractionDigits: 2 });
  }

  static calculateRefundAmout(reports) {
    let totalCancelOrderAmount = 0;
    let refundAmount = 0;
    let pendingAmount = 0;

    reports.map((report) => {
      totalCancelOrderAmount += Number(report.amount);
      if (report.status == "Pending") {
        pendingAmount += Number(report.amount);
      }
    });

    refundAmount = totalCancelOrderAmount - pendingAmount;

    return { totalCancelOrderAmount, refundAmount, pendingAmount };
  }

  static isTextValid(text) {
    if (text == "" || text == null) {
      return false;
    }
    if (!/^[^a-zA-Z0-9]/.test(text)) {
      return false;
    }
    return true;
  }

  static formatDateTime(isoString) {
    const date = new Date(isoString);

    return date
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(",", "");
  }

  static #removeIdColumn(list) {
    const data = [];
    list.map((item) => {
      const { id, ...rest } = item;
      data.push(rest);
    });
    return data;
  }

  static #formatCategories(data) {
    const cats = [];
    data.map((item) => {
      cats.push({ label: item.name, value: item.id });
    });
    return cats;
  }

  static async getOrderList(params, userToken) {
    return ApiService.GET_SALES_REPORT_LIST(params, userToken)
      .then((res) => {
        if (res.code == 200) {
          return {
            loading: false,
            message: res.message,
            data: this.#removeIdColumn(res.payload.records),
            page: res.payload.page,
            perPage: res.payload.perPage,
            total: res.payload.total,
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }

  static async getOrderReportList(params, userToken) {
    return ApiService.GET_ORDER_REPORT_LIST(params, userToken)
      .then((res) => {
        if (res.code == 200) {
          return {
            loading: false,
            message: res.message,
            data: this.#removeIdColumn(res.payload.records),
            page: res.payload.page,
            perPage: res.payload.perPage,
            total: res.payload.total,
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }

  static async getReportCategories(params, userToken) {
    return ApiService.GET_CATEGORY(params, userToken).then((res) => {
      if (res.code == 200) {
        const formatedCateogires = this.#formatCategories(res.payload.records);
        return formatedCateogires;
      }
    });
  }
}
